import api from '../lib/axios';
export async function getInvitation(token) {
    const { data } = await api.get(`/api/v1/auth/invitation/${token}`);
    return data.data;
}
export async function claimInvitation(token, password) {
    await api.post('/api/v1/auth/invitation/claim', { token, password });
}
